import React from "react";
import "../css/footer.css";
const Footer = () => {
  return (
    <div className="Footer">
      <a href="#">
        <img src="logo.png" alt="Logo" className="logo"/>
      </a>
      <div className="footerButtons">
        <a href="#"><i className="fa fa-facebook"/></a>
        <a href="#"><i className="fa fa-linkedin"/></a>
        <a href="#"><i className="fa fa-youtube"/></a>
        <a href="#"><i className="fa fa-instagram"/></a>
        </div>
    </div>
  );
};


export default Footer;